<template>
  <span v-if="!props.spin">{{props.text}}</span>
  <span v-else><div class="lds-ring"><div></div><div></div><div></div><div></div></div></span>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  text: String,
  spin: Boolean,
})
</script>
